export const addPercentageToNumber = <T extends number | `${number}`>(number: T): `${T}%` => `${number}%`
